import { DOCUMENT } from '@angular/common';
import { filter, map } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { Meta, Title } from '@angular/platform-browser';
import { ScullyRoutesService } from '@scullyio/ng-lib';
import { Component, OnInit, Inject } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Renderer2 } from '@angular/core';
@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
    urlPrefix: string;

    constructor(
        private meta: Meta,
        private router: Router,
        private platform: Platform,
        private titleService: Title,
        private scully: ScullyRoutesService,
        private activatedRoute: ActivatedRoute,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: any,
        @Inject('Window') private window: Window
    ) {
        this.urlPrefix = this.window.location.hostname;

        if (this.platform.ANDROID || this.platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }
    }

    ngOnInit(): void {
        const appTitle = this.titleService.getTitle();

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => {
                    let child = this.activatedRoute.firstChild;
                    while (child.firstChild) {
                        child = child.firstChild;
                    }
                    if (child.snapshot.data.title) {
                        return child.snapshot.data.title;
                    }
                    return appTitle;
                })
            )
            .subscribe((ttl) => {
                const route = this.router.url;

                if (!route.includes('#')) {
                    this.scrollToTop();
                }

                if (route.includes('/blogs')) {
                    this.updateMetaInfo();
                    this.addArticleSchema();
                } else {
                    this.titleService.setTitle(`Clearcals | ${ttl}`);
                }
            });
    }

    updateMetaInfo(): void {
        this.scully.getCurrent().subscribe((currentRoute) => {
            const { title, description, image, route } = currentRoute;

            // checks 
            if(!this.urlPrefix.startsWith('https://')) this.urlPrefix = 'https://' + this.urlPrefix;
            
            let url = `${this.urlPrefix}${route}`;

            // checks
            if(!route.endsWith('/')) url = url + '/';
            
            this.titleService.setTitle(title);

            this.meta.updateTag({ name: 'description', content: description });

            this.meta.updateTag({ property: 'og:url', content: url });
            this.meta.updateTag({ property: 'og:title', content: title });
            this.meta.updateTag({ property: 'og:image', content: image });
            this.meta.updateTag({
                property: 'og:description',
                content: description,
            });

            this.meta.updateTag({ name: 'twitter:url', content: url });
            this.meta.updateTag({ name: 'twitter:title', content: title });
            this.meta.updateTag({ name: 'twitter:image', content: image });
            this.meta.updateTag({
                name: 'twitter:description',
                content: description,
            });
        });
    }

    scrollToTop(): void {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
    }

    // function for adding article schema

    addArticleSchema(): void {
        this.scully.getCurrent().subscribe((currentRoute) => {
            const { title, image, author } = currentRoute;
            if (
                !this.document.getElementById('articleSchema') &&
                title &&
                image &&
                author
            ) {
                const {
                    title,
                    createdDate,
                    lastModified,
                    image,
                    author,
                    route,
                } = currentRoute;
                const article = {
                    '@context': 'http://schema.org',
                    '@type': 'Article',
                    headline: title,
                    image: {
                        '@type': 'ImageObject',
                        url: image,
                    },
                    datePublished: createdDate,
                    dateModified: lastModified,
                    author: [
                        {
                            '@type': 'Organization',
                            name: author,
                            url: 'http://clearcals.com',
                        },
                    ],
                };
                const script = this.renderer.createElement('script');
                script.type = 'application/ld+json';
                script.innerHTML = JSON.stringify(article);
                script.id = 'articleSchema';
                this.renderer.appendChild(this.document.head, script);
            }
        });
    }
    // end function for adding article schema
}
